import { useEffect, useState } from "react";
import { MethodologyList } from "./components/MethodologyList";
import { Methodology } from "./types";
import { useToast } from "../../hooks/use-toast";
import {
  useGetMethodologiesQuery,
  useAddMethodologyMutation,
  useUpdateMethodologyMutation,
  useDeleteMethodologyMutation,
} from "../../store/is/methodologyapi";

export function MethodologyPage() {
  const { data: methodologiesData, isLoading, error } = useGetMethodologiesQuery();
  const [addMethodology] = useAddMethodologyMutation();
  const [updateMethodology] = useUpdateMethodologyMutation();
  const [deleteMethodology] = useDeleteMethodologyMutation();
  const { toast } = useToast();

  useEffect(() => {
    if (methodologiesData) {
      console.log('Methodologies data:', methodologiesData);
    }
  }, [methodologiesData]);

  const handleAdd = async (methodology: Methodology) => {
    try {
      await addMethodology(methodology).unwrap();
      toast({
        title: "Success",
        description: "Methodology added successfully",
      });
    } catch (error) {
      console.error('Error adding methodology:', error);
      toast({
        title: "Error",
        description: "Failed to add methodology",
        variant: "destructive",
      });
    }
  };

  const handleEdit = async (methodology: Partial<Methodology> & { id: string }) => {
    try {
      console.log('methodology:', JSON.stringify(methodology, null, 2));
      const result = await updateMethodology(methodology).unwrap();
      console.log('Update API response:', result);
      toast({
        title: "Success",
        description: "Methodology updated successfully",
      });
    } catch (error) {
      console.error('Error updating methodology:', error);
      toast({
        title: "Error",
        description: "Failed to update methodology",
        variant: "destructive",
      });
    }
  };

  const handleDelete = async (id: string) => {
    try {
      await deleteMethodology(id).unwrap();
      toast({
        title: "Success",
        description: "Methodology deleted successfully",
      });
    } catch (error) {
      console.error('Error deleting methodology:', error);
      toast({
        title: "Error",
        description: "Failed to delete methodology",
        variant: "destructive",
      });
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    console.error('Error loading methodologies:', error);
    return <div>Error loading methodologies: {JSON.stringify(error)}</div>;
  }

  // Ensure methodologiesData is an array before filtering
  const methodologies = Array.isArray(methodologiesData) ? methodologiesData : [];

  // Validate methodologies data before rendering
  const validMethodologies = methodologies.filter(m => {
    const isValid = m.id && m.name && m.domain && m.asset_type && m.project_input_type;
    if (!isValid) {
      console.warn('Invalid methodology:', m);
    }
    return isValid;
  });

  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Methodologies</h1>
      <MethodologyList
        methodologies={validMethodologies}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </div>
  );
} 